import { toast } from 'react-toastify';

const IotmateToast = () => {
    const showToast = (message, type = 'success') => {
        const config = {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            style: {
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                padding: '16px',
                fontSize: '14px',
                fontWeight: '500'
            },
            progressStyle: {
                background: getProgressColor(type)
            }
        };

        toast[type](message, config);
    };

    const getProgressColor = (type) => {
        const colors = {
            success: 'linear-gradient(90deg, #10b981, #059669)',
            error: 'linear-gradient(90deg, #ef4444, #dc2626)',
            warning: 'linear-gradient(90deg, #f59e0b, #d97706)',
            info: 'linear-gradient(90deg, #3b82f6, #2563eb)',
            default: 'linear-gradient(90deg, #667eea, #764ba2)'
        };
        return colors[type] || colors.default;
    };

    return showToast;
};

// Optional: Add custom toast styles to your global CSS
export const toastStyles = `
    .Toastify__toast--success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }
    
    .Toastify__toast--error {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    }
    
    .Toastify__toast--warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    }
    
    .Toastify__toast--info {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
    }
    
    .Toastify__close-button {
        opacity: 0.8;
    }
    
    .Toastify__close-button:hover {
        opacity: 1;
    }
`;

export default IotmateToast;